import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AgentLayout from "../components/AgentLayout";
import UserNavigation from "./user-navigation";
import axiosInstance from "../../../utils/axiosInstance";
import BetHistoryContent from "../../client/bet-history/BetHistoryContent";

const AccountBets = () => {
  const { userId } = useParams();
  const [displayUsername, setDisplayUsername] = useState("");

  useEffect(() => {
    const fetchUserById = async () => {
      if (!userId) {
        return;
      }

      try {
        const response = await axiosInstance.get(`user/${userId}`);
        if (response?.data?.uname) {
          setDisplayUsername(response.data.uname);
        }
      } catch (error) {
        console.error("Error fetching user:", error);
        setDisplayUsername("");
      }
    };

    fetchUserById();
  }, [userId]);

  return (
    <AgentLayout>
      <div
        className="right-content-wrapper"
        style={{ background: "transparent" }}
      >
        <div className="bets-section-wrapper">
          <div className="row">
            <div className="col-12">
              <UserNavigation displayUsername={displayUsername} />
            </div>
            <div className="col-12 col-md-12">
              <BetHistoryContent
                targetUserId={userId}
                displayUsername={displayUsername}
              />
            </div>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default AccountBets;
